<template>
  <!-- 웹: 공용 네비게이션 (앱은 네비게이션 없이 노출) -->
  <Nav v-if="!isApp" />
  <!-- Nav는 fixed 라서 높이만큼 본문을 내린다 -->
  <div
    class="flex flex-1 bg-white"
    :style="{ paddingTop: isApp ? null : 'var(--nav-height, 80px)' }"
  >
    <div class="w-full max-w-[40rem] px-4 sm:px-6 mx-auto">
      <EduRegisterDonePage/>
    </div>
  </div>
</template>

<script>
// import LNavComponent from "@/components/LNavComponent.vue";
import Nav from "@/components/new/Nav.vue";
import EduRegisterDonePage from "@/pages/EduRegisterConfirmPage.vue";

export default {
  name: "EduRegisterConfirmView",
  components: {Nav, EduRegisterDonePage},
  computed: {
    isApp() {
      return this.$route.name === "eduRegisterDoneApp";
    },
  },
}
</script>

<style scoped>

</style>
